import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/cici/cici/components/BlogList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/cici/cici/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/cici/cici/node_modules/next/dist/client/image-component.js");
